/* eslint-disable */
import {propsDecorator} from "@/js/common/Domain/Service/mixins/decorators";
import ChildesAge from "@/js/common/Domain/Repository/ChildesAge";

@propsDecorator({
	model: ChildesAge
})
export default class ChildesCollection extends Backbone.Collection{}